import { Cms } from '@typings';

export const getResponsiveClassNames = (screenType: Cms.ScreenType) => ({
  wrapperDesktop: screenType === 'desktop',
  wrapperMobile: screenType === 'mobile',
  wrapperTablet: screenType === 'tablet',
});
